"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    transform: "translate(2.000000, 5.000000)",
    fill: "currentColor",
    fillRule: "nonzero",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      id: "Outline",
      transform: "translate(0.789474, 0.750000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M16.4035088,0 L1.92982456,0 C0.868421053,0 0,0.625 0,1.38888889 L0,11.1111111 C0,11.875 0.868421053,12.5 1.92982456,12.5 L16.4035088,12.5 C17.4649123,12.5 18.3333333,11.875 18.3333333,11.1111111 L18.3333333,1.38888889 C18.3333333,0.625 17.4649123,0 16.4035088,0 Z M11.5789474,10.6666667 L6.75438596,10.6666667 L6.75438596,2.41666667 L11.5789474,2.41666667 L11.5789474,10.6666667 Z M1.92982456,2.41666667 L4.8245614,2.41666667 L4.8245614,10.6666667 L1.92982456,10.6666667 L1.92982456,2.41666667 Z M13.5087719,10.6666667 L13.5087719,2.41666667 L16.4035088,2.41666667 L16.4035088,10.6666667 L13.5087719,10.6666667 Z",
        id: "Shape"
      })
    })
  })
}));